import { useDispatch, useSelector } from 'react-redux';
import {
  fetchGetRole,
  fetchGetRoles,
  fetchPostRole,
  fetchPutRole,
  fetchDeleteRole,
  cleanUpRole,
  cleanUpMessageRole,
  getPermissionsKeys
} from 'state-managament/role.slice';

export default function useRole(project) {
  const {
    error, 
    success, 
    isLoaded, 
    data, 
    permissionKeys 
  } = useSelector((state) => state.role);
  
  const dispatch = useDispatch();

  const cleanUp = () => dispatch(cleanUpRole());
  const cleanUpMessage = () => dispatch(cleanUpMessageRole());
  const getRol = () => dispatch(fetchGetRole());
  const getRoles = (args) => dispatch(fetchGetRoles(args));
  const postRole = (args) => dispatch(fetchPostRole(args));
  const deleteRole = (args) => dispatch(fetchDeleteRole(args));
  const putRole = (args) => dispatch(fetchPutRole(args));

  const getKeysPermissions = () => dispatch(getPermissionsKeys())

  return {
    error,
    success,
    isLoaded,
    data,
    permissionKeys,
    cleanUp,
    cleanUpMessage,
    getRol,
    getRoles,
    postRole,
    deleteRole,
    putRole,
    getKeysPermissions
  };

}
